"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _default = function _default(_ref) {
  var actionTypes = _ref.actionTypes,
      property = _ref.property;
  return (0, _defineProperty2.default)({}, actionTypes[property], function (state, action) {
    return state.set(property, action.payload[property]);
  });
};

exports.default = _default;
module.exports = exports.default;